const PROGRESS_BAR_COMPLETED_COLOR = "#00BB8C";
const PROGRESS_BAR_NOT_COMPLETED_FILL_COLOR = "#FFECF2";
const PROGRESS_BAR_NOT_COMPLETED_STROKE_COLOR = "#DD4C77";
function getProgressBarFillColor(isCompleted) {
  return isCompleted ? PROGRESS_BAR_COMPLETED_COLOR : PROGRESS_BAR_NOT_COMPLETED_FILL_COLOR;
}
function getProgressBarStrokeColor(isCompleted) {
  return isCompleted ? PROGRESS_BAR_COMPLETED_COLOR : PROGRESS_BAR_NOT_COMPLETED_STROKE_COLOR;
}
export {
  getProgressBarFillColor,
  getProgressBarStrokeColor
};
//# sourceMappingURL=utils.es.js.map
